exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr th {\n\tfont-weight: 500;\n\ttext-align: left;\n\tborder-bottom: 1px solid black;\n}\ntable tr:nth-child(even) {\n\tbackground: #f5f5f5;\n}\ntd,\nth {\n\tpadding: 10px;\n}\n.d-block {\n\tdisplay: block;\n}\n.f-bold {\n\tfont-weight: bold;\n}\n", ""]);

// exports
